import React from "react";
import Api from "../services/api";
import { Link } from "react-router-dom";
import withRouter from "../services/withRouter";

class Footer extends React.Component {

	componentDidMount = async () => {
		this.getPages();
		this.getVisitors();
	};

	constructor(props) {
		super(props);
		this.state = {
			"pages" : [],
			"visitors" : 0,
			"last_updated" : ""
		};
	}

	getPages = async()=>{
		var response = await Api.GetRequest({}, 'pages');
		if(response.status == 200){
			this.setState({'pages' : response.pages});
		}
		else{

		}
	}

	getVisitors = async()=>{
		var response = await Api.GetRequest({}, 'info');
		if(response.status == 200){
			this.setState({'visitors' : response.visitors, "last_updated" : response.last_updated});
		}
		else{

		}
	}


	render() {
		return (
			<>
				{/* <footer id="footer_area">
					<div class="container">
						<div class="row">
							<div class="col-lg-4 col-md-12 col-sm-12 col-12">
								<div class="footer_area_about">
									<img src="assets/img/logo.png" alt="img"/>
									<p>Lorem ipsum dolor sit amet consec elit sed eiusmod tempor incididunt ut labore etdolore magna
										aliqua.</p>
									<h6><strong>Address:</strong> 858 Walnutwood Ave. Webster, NY 14580</h6>
									<h6><strong>Phone:</strong> <a href="tel:123-284-2554">+011 234-567-890</a></h6>
									<h6><strong>Email:</strong> <a href="mailto:info@example.com">info@example.com</a></h6>
								</div>
							</div>
							{this.state.pages.length > 0 &&
								<div class="col-lg-4 col-md-6 col-sm-12 col-12">
									<div class="footer_navitem_ara">
										<h3>Quick links</h3>
										<div class="nav_item_footer">
											<ul>
												{this.state.pages.map((page)=>{
													return(
														<li><Link to={`/page/${page.id}`}>{page.title}</Link></li>
													)
												})}
											</ul>
										</div>

									</div>
								</div>
							}
							
							<div class="col-lg-4 col-md-6 col-sm-12 col-12">
								<div class="footer_navitem_ara">
									<h3>Support</h3>
									<div class="nav_item_footer">
										<ul>
											<li><a href="faqs.html">Help &amp; FAQ</a></li>
											<li><a href="causes.html">Causes</a></li>
											<li><a href="events.html">Events</a></li>
											<li><a href="contact.html">Contact us</a></li>
											<li><a href="terms-service.html">Terms of service</a></li>
										</ul>
									</div>
								</div>
							</div>
							
						</div>
					</div>
				</footer> */}

				<div className="copyright_area premium-footer">
					<div className="container">
						<div className="row align-items-center">
						
							<div className="col-12 col-md-6 mb-3 mb-md-0">
								<div className="justify-content-center justify-content-md-start d-flex align-items-center">
									<Link to={'/home'}><img src="/assets/img/logo.png" alt="logo" style={{'width' : '80px', 'marginRight': '8px'}}/></Link>
									<div className="justify-content-center d-flex align-items-left flex-column px-2" style={{'borderLeft' : "2px solid rgba(255,255,255,0.15)"}}>
										<Link to={'/home'} className="text-decoration-none"><h4 className="mx-3 footer-logo-title" style={{'color' : '#FFFFFF', 'margin': 0}}>SAHYOG SETU PORTAL</h4></Link>
										<a href="https://www.upliftlivefoundation.org/" className="text-decoration-none"><p className="mt-1 mx-3 footer-sub-title" style={{'margin': 0}}>UPLIFT LIVE FOUNDATION</p></a>
									</div>
								</div>
							</div>
							<div className="col-12 col-md-6">
								<div className="justify-content-center justify-content-md-end d-flex align-items-center flex-wrap mt-3 mt-md-0">
									<Link to="https://www.facebook.com/upliftlivefoundation.org" target="__blank" className="social-icon-btn"><i className="fab fa-facebook-f"></i></Link>
									<Link to="https://twitter.com/x/migrate?tok=7b2265223a222f75706c6966746c6976656f7267222c2274223a313733373330383834397d2cd83b85b071cad33ba53d08ea845199" target="__blank" className="social-icon-btn"><i className="fab fa-twitter"></i></Link>
									<Link to="https://www.instagram.com/upliftlivefoundationorg/" target="__blank" className="social-icon-btn"><i className="fab fa-instagram"></i></Link>
									<Link to="https://www.linkedin.com/company/uplift-live-foundation" target="__blank" className="social-icon-btn"><i className="fab fa-linkedin-in"></i></Link>
									<Link to="https://www.youtube.com/user/Wix" target="__blank" className="social-icon-btn"><i className="fab fa-youtube"></i></Link>
								</div>
							</div>
						</div>
						
						<hr style={{'borderColor' : 'rgba(255,255,255,0.1)', 'margin': '25px 0'}}></hr>
						
						<div className="row align-items-center">
							<div className="col-lg-12 col-md-12 col-sm-12 col-12">
								<div className="copyright_left">
									<div className="justify-content-center my-2 d-flex align-items-center flex-wrap text-center gap-1">
										{this.state.pages.map((page, index)=>{
											return(
												<React.Fragment key={page.id}>
													{index === 0 &&
														<Link to={`/page/${page.id}`} className="py-0 mx-3 footer-page-link">{page.title}</Link>
													}
													{index > 0 &&
														<Link to={`/page/${page.id}`} className="ml-3 px-3 py-0 footer-page-link" style={{ 'borderLeft': "1px solid rgba(255,255,255,0.15)" }}>{page.title}</Link>
													}
												</React.Fragment>
											)
										})}
									</div>
								</div>
							</div>
						</div>
						
						<div className="row my-4 align-items-center text-center text-md-start">
							<div className="col-12 col-md-6 mb-3 mb-md-0">
								<p style={{'color' : '#94a3b8', 'fontSize': '13px'}} className="mb-0">Copyright © 2025 SAHYOG SETU PORTAL, UPLIFT LIVE FOUNDATION | All Rights Reserved</p>
							</div>
							<div className="col-12 col-md-6 justify-content-center justify-content-md-end d-flex align-items-center align-items-md-end mt-3 mt-md-0">
								<div className="footer-stats-container d-flex flex-wrap gap-2 justify-content-center justify-content-md-end">
									<div className="stat-capsule">
										<span className="stat-dot pulse-blue"></span>
										<span className="stat-label">Last Updated:</span>
										<span className="stat-value">{this.state.last_updated || 'Recent'}</span>
									</div>
									<div className="stat-capsule">
										<span className="stat-dot pulse-green"></span>
										<span className="stat-label">Live Visitors:</span>
										<span className="stat-value">{this.state.visitors || '0'}</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</>
		);
	}
}

export default Footer;
